import { useEffect, useRef, useState } from "react";

import './Pagination.scss';
import store from "features/store";
import PaginationBox from "features/components/base/public/HOC/PaginationBox";
export const Pagination = ({ loading, page, onPageChangeCallback, type,pageData }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState([]);

    const pageDetail = useRef({ total: 0, size: 0 });

    useEffect(() => {
        if(pageData?.currentindex){
            setCurrentPage(pageData?.currentindex)
        }
        if ( typeof page === 'undefined' ) {
            page = {};
        }
        let total = page.total || pageData?.total
        if (total && page.size ) {

            if ( total !== pageDetail.current.total ) {
                setCurrentPage(1);
            }

            pageDetail.current = { total:total , size: page.size };

        } else if ( typeof total=== 'undefined' && typeof page.size !== 'undefined' ) {
            pageDetail.current = { total: pageDetail.current.total, size: page.size };
        } else if ( typeof total === 'undefined' && typeof page.size === 'undefined' ) {
            pageDetail.current = { total: 0, size: 0 };
            setPages([1]);
            setCurrentPage(1);
            return;
        }

        let pageList = [];
        let count = Math.ceil(pageDetail.current.total / page.size);
        
        const left = currentPage == count ? currentPage - 4 : currentPage - 2;
        const right = currentPage > 2 ? currentPage + 2 : currentPage + 4;

        for (let i = 1; i <= count;) {
            if (i === 1 || i === count || (i >= left && i <= right)) {
                pageList.push(i);
            } else {
                if (pageList[pageList.length - 1] !== null) {
                    pageList.push(null);
                }
            }
            i++;
        }

        setPages(pageList);
    }, [page,pageData,currentPage]);

    const onChangePage = (previousPageNumber, currentPageNumber) => {
        store.dispatch({ type: 'FOOTER', payload: false });

        if ( type == "stories" ) {
             if ( previousPageNumber !== currentPageNumber ) {
                setCurrentPage(currentPageNumber);
                const pagePayload = { "size": 8 };

                // Going to next page or previouse page.
                if (  (previousPageNumber + 1) === currentPageNumber ) {
                    pagePayload.pagenumber = currentPageNumber;
                } else if ( (previousPageNumber - 1) === currentPageNumber ) {
                    pagePayload.pagenumber = currentPageNumber;
                } else {
                    // Page jump identified
                    pagePayload.pagenumber = currentPageNumber;
                }
                onPageChangeCallback && onPageChangeCallback(pagePayload,currentPageNumber,previousPageNumber);
             } 
        } else {
            if ( previousPageNumber !== currentPageNumber ) {
                setCurrentPage(currentPageNumber);

            const pagePayload = { size: page.size };

            // Going to next page or previouse page.
            if (  (previousPageNumber + 1) === currentPageNumber ) {
                pagePayload.next = page?.keyset?.next;
            } else if ( (previousPageNumber - 1) === currentPageNumber ) {
                pagePayload.previous = page?.keyset?.previous;
            } else {
                // Page jump identified
                pagePayload.total = pageDetail.current.total;
                pagePayload.from = previousPageNumber;
                pagePayload.to = currentPageNumber;

                if ( currentPageNumber > previousPageNumber ) {
                    pagePayload.next = page?.keyset?.next;
                } else {
                    pagePayload.previous = page?.keyset?.previous;
                }
            }

            onPageChangeCallback && onPageChangeCallback(pagePayload,currentPageNumber,previousPageNumber,pageDetail.current?.total);

            const scrollContainer = document.querySelector('.scroll-content');
            if ( scrollContainer ) {
                scrollContainer.scrollTop = 0;
            } else {
                window.scrollTo(0, 0);
            }
        }
        }
    };

    return (
        <div className='pagination-box'>
            {
                loading ?  null : pages.length > 1 &&
                pages.map((page) => (
                    page === null ? 
                    <div className="page-dots">
                        <img alt="pagination-dots" src={`${process.env.PUBLIC_URL}/static/icons/common-icons/dots.svg`} />
                    </div> :
                    <div role="button" className={`page-item ${page === currentPage ? 'active' : ''}`} onClick={() => { onChangePage(currentPage, page); }}>
                        {page}
                    </div>
                ))
            }
        </div>
    );
};

export const PaginationDots = ({ loading, pageSize, totalSize, scrollRef ,timerEvent=false}) => {
    const [dots, setDots] = useState(0);
    const [activeDotIndex, setActiveDotIndex] = useState(0);

    const maxDots = useRef(0);
    const paginationDotsRef = useRef(null);

    useEffect(() => {
        if ( pageSize > 0 && totalSize > 0 ) {
            const count = Math.ceil(totalSize / pageSize);
            setDots(count);
            maxDots.current = count;
        }
    }, [pageSize, totalSize]);

    useEffect(() => {
        if ( scrollRef && scrollRef.current ) {
            scrollRef.current.addEventListener('scroll', (event) => { handleScroll(event); });
            scrollRef.current.addEventListener('scrollend', (event) => { handleScroll(event); });
        }

        return () => {
            if ( scrollRef && scrollRef.current ) {
                scrollRef.current.removeEventListener('scroll', (event) => { handleScroll(event); });
                scrollRef.current.removeEventListener('scrollend', (event) => { handleScroll(event); });
            }
        };
    }, [scrollRef?.current]);

    const handleScroll = (event) => {
        if ( event.target.scrollLeft + event.target.clientWidth >= event.target.scrollWidth - 1 ) {
            setActiveDotIndex(maxDots.current - 1);
        } else {
            setActiveDotIndex(Math.round(scrollRef.current.scrollLeft / scrollRef.current.offsetWidth));
        }
    };

    const onChangePage = (index) => {
        if ( scrollRef.current ) {
            scrollRef.current.scrollTo({
                left: index * scrollRef.current.offsetWidth,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className={`pagination-dots-box ${paginationDotsRef.current?.scrollWidth > paginationDotsRef.current?.clientWidth ? '' : 'justify-content-center'}`} ref={paginationDotsRef}>
            {
                loading ? null :
                    dots > 1 && [...Array(dots)].map((elem, index) => <div key={`pagination-dot-${elem}-${index}`} role="button" className={`dots ${activeDotIndex === index ? 'active' : ''}`} onClick={() => { onChangePage(index); }}></div>)
            }
        </div>
    );
};